import {Card, CardBody, Col, Media, Tooltip} from "reactstrap";
import moment from "moment";
import {HasPermission} from 'react-role-permission'
import './sessionCard.scss'
import {IconLiTooltip} from "../iconLiTooltip/IconLiTooltip";
export function SessionCard(sessionCard) {
  console.log(sessionCard)
  const {card} = sessionCard;

  return (
    <Col xl="4 xl-100">
      <Card
        className={`${
          card ? "" : "ribbon-vertical-left-wrapper"
        } b-t-primary`}
      >
        <div className="job-search">
          <CardBody>
            <div className="product-box">
              <div className="product-img">
                <Media>
                  <img
                    className="img-100 img-fluid m-r-20"
                    src='/images/video_icon_sm.png'
                    alt=""
                  />
                  <Media body>

                    <h6 className="f-w-600">
                      {card.name }
                      {card.isPublic ? (
                        <span className="badge badge-primary public">
                                    Pubblica
                                  </span>
                      ) : ''}

                      {(card.ribbion == 'true') ? (
                        <div className="ribbon ribbon-bookmark ribbon-vertical-left ribbon-danger">
                          <i className="icofont icofont-social-youtube-play"></i>
                        </div>
                      ) : ''}
                    </h6>
                    <p>
                      {moment(new Date(card.timestamp)).format('DD/MM/YYYY')}
                    </p>


                  </Media>
                </Media>
                <p>{card.description}</p>
                <div className="product-hover">
                  <ul>
                    <li id={`watch-link-${card.id}`}>
                      <IconLiTooltip
                          icon={'icon-eye'}
                          id={card.id}
                          link={`/sessions/view?id=${card.id}`}
                          tooltipMessage={'Guarda'}
                          target={`watch-link-${card.id}`}
                      />
                    </li>
                    {HasPermission('/sessions/manage') ?
                      <li id={`manage-link-${card.id}`}>
                        <IconLiTooltip
                            icon={'icofont icofont-video-clapper'}
                            id={card.id}
                            link={`/sessions/manage?id=${card.id}`}
                            tooltipMessage={'Gestisci'}
                            target={`manage-link-${card.id}`}
                        />
                      </li> :
                      <></>}

                    {HasPermission('/sessions/add') ?
                      <li id={`edit-link-${card.id}`}>
                        <IconLiTooltip
                            icon={'icon-pencil'}
                            id={card.id}
                            link={`/sessions/add?id=${card.id}`}
                            tooltipMessage={'Modifica'}
                            target={`edit-link-${card.id}`}
                        />
                      </li> :
                      <></>}
                  </ul>
                </div>
              </div>
            </div>
          </CardBody>
        </div>
      </Card>

    </Col>
  )
}
